import React, { useState, useEffect, useContext } from 'react';
import { CartContext } from '../context/CartContext';
import { SettingsContext } from '../context/SettingsContext';
import { useLocation } from 'react-router-dom';
import Badge from '@mui/material/Badge';
import './BanHeader.css';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';

const BanHeader = ({ toggleCart, isCartOpen }) => {
  const location = useLocation(); // 👈 pour connaître la route actuelle
  const { cartItems } = useContext(CartContext);
  const { vacances } = useContext(SettingsContext);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [infos, setInfos] = useState({});
  const [slides, setSlides] = useState([]); // Remplace la constante slides

  useEffect(() => {
    fetch(`/assets/json/infos-generale.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => setInfos(data))
      .catch(error => console.error('Erreur lors de la récupération des informations générales:', error));
  }, []);

  useEffect(() => {
    fetch(`/assets/json/ban-slides.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => {
        console.log('Slides data:', data); // 👈 Ajout du console.log ici
        setSlides(data);
      })
      .catch(error => console.error('Erreur lors de la récupération du carousel:', error));
  }, []);

  const nextSlide = () => {
    setCurrentSlide((currentSlide + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((currentSlide - 1 + slides.length) % slides.length);
  };

  const totalItemsInCart = cartItems.reduce((total, item) => total + (item.quantity || 1), 0);

  const formatDateFr = (iso) => {
    if (!iso) return '';
    const [y, m, d] = iso.split('-');
    return `${d}/${m}/${y}`;
  };

  return (
    <header className="ban-header">
      {vacances.active && (
        <div className="vacances-banner">
          {vacances.message
            ? vacances.message
            : `Fermeture pour congés du ${formatDateFr(vacances.debut)} au ${formatDateFr(vacances.fin)}. Les commandes en ligne sont temporairement indisponibles.`}
        </div>
      )}
      <div className="top-banner">
        <div className="logo">
          <a href='./'><img src={infos.logoResto} alt="Logo" /></a>
        </div>
        <div className="Acces-carte">
          <a href="/notre-carte-a-emporter" className="carte-link">
            <RestaurantMenuIcon style={{ verticalAlign: 'middle', marginRight: 6 }} />
            Passez une commande à emporter
          </a>
        </div>
        <div className="contact-info">
          <p>Adresse: {infos.adresse}</p>
          <p>Téléphone: {infos.telephone}</p>
          <p>Email: {infos.email}</p>
        </div>
        <div className="badge-container">
          <Badge className='badge' badgeContent={totalItemsInCart} color="primary" />
          <button className="toggle-button" onClick={toggleCart}>
            {isCartOpen ? 'Fermer' : 'Détail Commande'}
          </button>
        </div>
      </div>

      {/* 👉 Le carrousel uniquement sur la page d'accueil */}
      {location.pathname === '/' && slides.length > 0 && slides[currentSlide] && (
        <div className="carousel-container">
          <div className="carousel-slide">
            <p
              className="legend"
              dangerouslySetInnerHTML={{ __html: slides[currentSlide].text }}
            />
            <img
              src={slides[currentSlide].src}
              alt={`Image ${currentSlide + 1}`}
            />
          </div>
          <button className="carousel-button prev" onClick={prevSlide}>‹</button>
          <button className="carousel-button next" onClick={nextSlide}>›</button>
        </div>
      )}
    </header>
  );
};

export default BanHeader;
